import React from 'react';
export function ProblemSection() {
  return <section className="py-16 px-4 bg-[#FFF8F0]" data-id="element-87">
      <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-88">
        <p className="text-xl md:text-2xl text-[#5C2D0E] leading-relaxed" data-id="element-89">
          Comprás ingredientes, seguís cada paso… y al final la torta no sube,
          queda dura o se desarma.
        </p>
        <p className="text-xl md:text-2xl text-[#5C2D0E] leading-relaxed font-semibold text-[#3C1518]" data-id="element-90">
          A todos nos pasó.
        </p>
        <p className="text-xl md:text-2xl text-[#5C2D0E] leading-relaxed" data-id="element-91">
          El problema no es tu horno. No es tu molde. Ni siquiera es tu
          habilidad para cocinar.
        </p>
        <p className="text-xl md:text-2xl text-[#5C2D0E] leading-relaxed" data-id="element-92">
          El problema es que la mayoría de recetas en internet no explican los
          detalles que realmente hacen que una torta salga perfecta.
        </p>
        <p className="text-xl md:text-2xl text-[#5C2D0E] leading-relaxed text-[#C2410C]" data-id="element-93">
          Pequeños errores en proporciones, tiempos o técnicas pueden arruinar
          todo el resultado.
        </p>
      </div>
    </section>;
}